/**
 * Build identity for the footer — inlined at compile time (CRA DefinePlugin),
 * same idea as Vite `define: { 'import.meta.env.VITE_APP_VERSION': pkg.version }`.
 *
 * Not stored in overrides.js (that file is env/config only, gitignored).
 */

export const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0';
export const GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT || 'dev';
